/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { monoFont } from './monolith.tokens'

interface PropsType {
	/** 렌더할 태그. 히어로는 h1, 카드·행에서는 span. */
	as?: 'h1' | 'h2' | 'span' | 'div'
	/** 전체 글자 크기 (px 또는 clamp 문자열) */
	size?: string | number
	/** true 면 라인 이름 "KOINOS" 만 그린다 (/products 라인 행 제목). 모델라인 없음 */
	brandOnly?: boolean
	className?: string
	style?: React.CSSProperties
}

/**
 * "KOINOS PLS 8" 제품 워드마크.
 *
 * 워드마크 규정(SSOT: kedemUpdater/index.html): KOINOS = Science Gothic Bold(700),
 * 모델라인 = MuseoModerno Thin(100). 두 단어 사이는 일반 공백 하나.
 * 폰트는 App.css 의 @font-face(Science Gothic) 와 index.html 의 Google Fonts(MuseoModerno) 에서 온다.
 */
export const KoinosWordmark = (props: PropsType) => {
	const Tag = props.as ?? 'span'
	// size 를 안 주면 인라인 font-size 를 아예 두지 않는다 — 인라인 'inherit' 는 className 의 크기를 덮어버린다.
	const sizeStyle: React.CSSProperties =
		props.size === undefined ? {} : { fontSize: props.size }

	return (
		<Tag
			css={style}
			className={props.className}
			style={{ ...sizeStyle, ...props.style }}
			aria-label={props.brandOnly === true ? 'Koinos' : 'Koinos PLS 8'}
		>
			<span className="kwKoinos">KOINOS</span>
			{props.brandOnly !== true && (
				<>
					{' '}
					<span className="kwModel">PLS 8</span>
				</>
			)}
		</Tag>
	)
}

const style = css({
	margin: 0,
	lineHeight: 1,
	letterSpacing: '-0.015em',
	whiteSpace: 'nowrap',

	'.kwKoinos': {
		fontFamily: monoFont.koinos,
		fontWeight: 700,
	},
	'.kwModel': {
		fontFamily: monoFont.model,
		fontWeight: 100,
	},
})
